import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useMockPayToStore = create(
  persist(
    (set, get) => ({
      isRejected: false,
      setRejected: (value) => {
        set({
          isRejected: value,
        });
      },
      isCancelled: false,
      setCancelled: (value) => {
        set({
          isCancelled: value,
        });
      },
    }),
    {
      name: 'mock-payto-store', // localStorage key
    }
  )
);

export default useMockPayToStore;
